import React from "react";
import { Link } from "react-router-dom";
import "./Error404.css";
import errorImage from "../Images/Error404.webp";

const Error404 = () => {
  console.log('Error404 component rendering'); // Debug log
  
  return (
    <div className="error-container">
      <img src={errorImage} alt="Page Not Found" className="error-image" />
      <h1 className="error-title">404 - Page Not Found</h1>
      <p className="error-text">
        Oops! The page you are looking for doesn't exist or has been moved.
      </p>
      <Link to="/">
        <button className="error-btn">Go Back Home</button>
      </Link>
    </div>
  );
};

export default Error404;